import { render, staticRenderFns } from "./updateTheme.vue?vue&type=template&id=e5285c90&lang=pug"
import script from "./updateTheme.vue?vue&type=script&lang=js"
export * from "./updateTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports